(function () {
    var swatches = document.querySelectorAll('.swatch-a-tag-custom');
    var priceEl = document.querySelector('.bundle-builder__price');
    var tagEl = document.querySelector('.bundle-builder__preview-tag');
    var captionEl = document.querySelector('.bundle-builder__preview-caption');
    var imageEl = document.querySelector('.bundle-builder__preview-image');

    var braletteImageEl = document.querySelector('[data-role="bralette-image"]');
    var braletteNameEl = document.querySelector('[data-role="bralette-name"]');
    var bralettePriceEl = document.querySelector('[data-role="bralette-price"]');
    var braletteSizesEl = document.querySelector('[data-role="bralette-sizes"]');

    var summaryBraletteName = document.querySelector('[data-role="summary-bralette-name"]');
    var summaryBralettePrice = document.querySelector('[data-role="summary-bralette-price"]');
    var summaryBottomName = document.querySelector('[data-role="summary-bottom-name"]');
    var summaryBottomPrice = document.querySelector('[data-role="summary-bottom-price"]');
    var summaryPartnerRow = document.querySelector('[data-role="summary-partner-row"]');
    var summaryPartnerName = document.querySelector('[data-role="summary-partner-name"]');
    var summaryPartnerPrice = document.querySelector('[data-role="summary-partner-price"]');
    var saveMessageEl = document.querySelector('.bundle-builder__save-message');
    var defaultSaveMessage = saveMessageEl ? saveMessageEl.textContent : '';
    var summaryDiscountEl = document.querySelector('[data-role="summary-discount"]');

    // strikethrough original price — shown next to the discounted total in
    // the "Your Bundle" summary card and on the Add to Cart button,
    // whenever a discount is currently applied.
    var summaryOriginalPriceEl = document.querySelector('[data-role="summary-original-price"]');
    var addBtnOriginalPriceEl = document.querySelector('[data-role="add-btn-original-price"]');

    var mobileItemsEl = document.querySelector('[data-role="mobile-bar-items"]');
    var mobileTotalEl = document.querySelector('[data-role="mobile-bar-total"]');
    var mobileDiscountEl = document.querySelector('[data-role="mobile-bar-discount"]');
    var mobileBarButton = document.querySelector('[data-role="mobile-bar-button"]');

    // second summary row, only used when Partner → Women's tab is active
    var summaryPartnerRow2 = document.querySelector('[data-role="summary-partner-row-2"]');
    var summaryPartnerSwatch2 = document.querySelector('[data-role="summary-partner-swatch-2"]');
    var summaryPartnerName2 = document.querySelector('[data-role="summary-partner-name-2"]');
    var summaryPartnerPrice2 = document.querySelector('[data-role="summary-partner-price-2"]');

    var bottomGrid = document.querySelector('[data-role="bottom-grid"]');
    var bottomButtons = bottomGrid
    ? Array.prototype.slice.call(bottomGrid.querySelectorAll('.bundle-builder__style-card[data-type]'))
    : [];
    var bottomSizesEl = document.querySelector('[data-role="bottom-sizes"]');

    // your bundle color change
    var summaryBraletteSwatch = document.querySelector(
        '[data-role="summary-bralette-swatch"]'
    );

    var summaryBottomSwatch = document.querySelector(
        '[data-role="summary-bottom-swatch"]'
    );

    var summaryPartnerSwatch = document.querySelector(
        '[data-role="summary-partner-swatch"]'
    );
   // your bundle color change

    // ---------------------------------------------------------
    // PREVIEW THUMBNAILS
    // Small clickable thumbnails under the hero preview image —
    // one for the bralette, one for the bottoms, one (hidden until
    // partner is enabled) for the partner item. Clicking a thumbnail
    // swaps it into the big hero image.
    //
    // IMAGE QUALITY FIX: the small thumbnail chips use the LOW-RES
    // "image" field (400x400 — plenty for a 64px chip), but the big
    // hero window now uses a separate HIGH-RES "image_large" field
    // (1200x1200) so it never looks blurry/pixelated when stretched.
    // ---------------------------------------------------------
    var previewThumbBraletteImg = document.querySelector('[data-role="preview-thumb-bralette-img"]');
    var previewThumbBottomImg = document.querySelector('[data-role="preview-thumb-bottom-img"]');
    var previewThumbPartnerImg = document.querySelector('[data-role="preview-thumb-partner-img"]');
    var previewThumbPartnerBtn = document.querySelector('[data-role="preview-thumb-partner"]');
    var previewThumbButtons = document.querySelectorAll('.bundle-builder__preview-thumb');
    var previewThumbPartnerBraletteBtn = document.querySelector('[data-role="preview-thumb-partner-bralette"]');
    var previewThumbPartnerBraletteImg = document.querySelector('[data-role="preview-thumb-partner-bralette-img"]');

    var partnerMenThumbImage = null;
    var partnerMenHeroImage = null; // NEW: high-res version for the hero window
    var partnerWomenThumbImage = null;
    var partnerWomenHeroImage = null; // NEW: high-res version for the hero window
    var partnerWomenBraletteThumbImage = null;

    function updatePartnerThumbDisplay() {
        if (!previewThumbPartnerBtn || !previewThumbPartnerImg) return;

        var thumbUrl = partnerTab === 'men' ? partnerMenThumbImage : partnerWomenThumbImage;
        var heroUrl = partnerTab === 'men' ? partnerMenHeroImage : partnerWomenHeroImage;

        if (!partnerEnabled || !thumbUrl) {
            previewThumbPartnerBtn.style.display = 'none';
            previewThumbPartnerImg.style.backgroundImage = '';

            if (previewThumbPartnerBraletteBtn) {
                previewThumbPartnerBraletteBtn.style.display = 'none';
                if (previewThumbPartnerBraletteImg) previewThumbPartnerBraletteImg.style.backgroundImage = '';
            }

            var wasActive =
                previewThumbPartnerBtn.classList.contains('bundle-builder__preview-thumb--active') ||
                (previewThumbPartnerBraletteBtn && previewThumbPartnerBraletteBtn.classList.contains('bundle-builder__preview-thumb--active'));

            if (wasActive) {
                previewThumbPartnerBtn.classList.remove('bundle-builder__preview-thumb--active');
                if (previewThumbPartnerBraletteBtn) previewThumbPartnerBraletteBtn.classList.remove('bundle-builder__preview-thumb--active');

                var braletteThumb = document.querySelector('[data-role="preview-thumb-bralette"]');
                if (braletteThumb) braletteThumb.click();
            }

            return;
        }

        // Primary partner thumb — Men's boxer OR Women's bottoms
        previewThumbPartnerBtn.style.display = '';
        previewThumbPartnerImg.style.backgroundImage = 'url("' + thumbUrl + '")';
        previewThumbPartnerImg.style.backgroundSize = 'cover';
        previewThumbPartnerImg.style.backgroundPosition = 'center';

        if (previewThumbPartnerBtn.classList.contains('bundle-builder__preview-thumb--active')) {
            setHeroImage(heroUrl || thumbUrl);
        }

        // NEW: second thumb, only for Women's tab — partner's bralette.
        // Men's stays hidden (only has one item).
        if (previewThumbPartnerBraletteBtn && previewThumbPartnerBraletteImg) {
            if (partnerTab === 'women' && partnerWomenBraletteThumbImage) {
                previewThumbPartnerBraletteBtn.style.display = '';
                previewThumbPartnerBraletteImg.style.backgroundImage = 'url("' + partnerWomenBraletteThumbImage + '")';
                previewThumbPartnerBraletteImg.style.backgroundSize = 'cover';
                previewThumbPartnerBraletteImg.style.backgroundPosition = 'center';

                if (previewThumbPartnerBraletteBtn.classList.contains('bundle-builder__preview-thumb--active')) {
                    setHeroImage(partnerWomenBraletteThumbImage);
                }
            } else {
                var wasBraletteThumbActive = previewThumbPartnerBraletteBtn.classList.contains('bundle-builder__preview-thumb--active');
                previewThumbPartnerBraletteBtn.style.display = 'none';
                previewThumbPartnerBraletteImg.style.backgroundImage = '';

                if (wasBraletteThumbActive) {
                    previewThumbPartnerBraletteBtn.classList.remove('bundle-builder__preview-thumb--active');
                    var fallbackBralette = document.querySelector('[data-role="preview-thumb-bralette"]');
                    if (fallbackBralette) fallbackBralette.click();
                }
            }
        }
    }

    function setHeroImage(url) {
    if (imageEl && url) {
        imageEl.style.backgroundImage = 'url(' + url + ')';
        imageEl.style.backgroundSize = 'cover';
        imageEl.style.backgroundPosition = 'center';
    }
    }

    previewThumbButtons.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
        var img = this.querySelector('span');
        var bg = img ? img.style.backgroundImage : '';
        // strips the `url("...")` wrapper down to the raw URL
        var url = bg.slice(5, -2);
        setHeroImage(url);

        previewThumbButtons.forEach(function (t) {
        t.classList.remove('bundle-builder__preview-thumb--active');
        });
        this.classList.add('bundle-builder__preview-thumb--active');
    });
    });
    // ===================== END PREVIEW THUMBNAILS SETUP =====================

    // ---------------------------------------------------------
    // SIZE GUIDE modal
    // ---------------------------------------------------------
    var sgOverlay = document.getElementById('bbSizeGuideOverlay');
    var sgTitleEl = document.getElementById('bbSizeGuideTitle');
    var sgContentEl = document.getElementById('bbSizeGuideContent');
    var sgCloseBtn = document.getElementById('bbSizeGuideClose');

    // Updated whenever a bottoms/partner selection changes so the
    // "Size guide" button always reflects the currently selected product.
    var selectedBottomSizeGuide = null;
    var selectedPartnerSizeGuide = null; // what the "partner" Size guide button actually opens (synced below)

    function openSizeGuide(data) {
    if (!sgOverlay) return;
    if (sgTitleEl) sgTitleEl.textContent = (data && data.title) ? data.title : 'Size guide';
    if (sgContentEl) sgContentEl.innerHTML = (data && data.content) ? data.content : '<p>Size guide coming soon.</p>';
    sgOverlay.classList.add('bundle-builder__sg-overlay--open');
    }

    function closeSizeGuide() {
    if (!sgOverlay) return;
    sgOverlay.classList.remove('bundle-builder__sg-overlay--open');
    }

    if (sgCloseBtn) sgCloseBtn.addEventListener('click', closeSizeGuide);
    if (sgOverlay) {
    sgOverlay.addEventListener('click', function (e) {
        if (e.target === sgOverlay) closeSizeGuide();
    });
    }
    document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSizeGuide();
    });

    // Any element with data-sg-kind="bralette" | "bottoms" | "partner"
    // opens the modal with that step's currently selected product's guide.
    document.querySelectorAll('[data-sg-kind]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        var kind = this.dataset.sgKind;
        var data = null;

        if (kind === 'bralette') {
        var activeSwatch = document.querySelector('.swatch-a-tag-custom.border-blue-500');
        if (activeSwatch && activeSwatch.dataset.sizeGuide) {
            try {
            data = JSON.parse(activeSwatch.dataset.sizeGuide);
            } catch (err) {
            data = null;
            }
        }
        } else if (kind === 'bottoms') {
        data = selectedBottomSizeGuide;
        } else if (kind === 'partner') {
        // selectedPartnerSizeGuide is kept in sync with whichever
        // partner tab (Men's / Women's) is currently active — see
        // syncPartnerSizeGuide() below.
        data = selectedPartnerSizeGuide;
        }

        openSizeGuide(data);
    });
    });

    // ---------------------------------------------------------
    // PARTNER (MEN'S) elements/data
    // ---------------------------------------------------------
    var partnerToggle = document.querySelector('.bundle-builder__partner-toggle');
    var partnerContent = document.querySelector('.bundle-builder__partner-content');
    var partnerImageEl = document.querySelector('[data-role="partner-image"]');
    var partnerNameEl = document.querySelector('[data-role="partner-name"]');
    var partnerPriceEl = document.querySelector('[data-role="partner-price"]');
    var partnerSizesEl = document.querySelector('[data-role="partner-sizes"]');

    var partnerData = [];
    try {
    partnerData = JSON.parse(document.getElementById('bundle-builder-partner-data').textContent).filter(function (r) {
        return r && r.style;
    });
    } catch (e) {
    partnerData = [];
    }
    var partnerMap = {};
    partnerData.forEach(function (r) {
    var key = (r.style || '').trim().toLowerCase();
    partnerMap[key] = r;
    });

    var partnerEnabled = false;
    var selectedPartnerVariantId = null;
    var selectedPartnerCents = 0;
    var partnerMenSizeGuide = null; // Men's currently selected product's size guide

    // ---------------------------------------------------------
    // PARTNER (WOMEN'S) elements/data
    // ---------------------------------------------------------
    var partnerTabButtons = document.querySelectorAll('[data-partner-tab]');
    var partnerMenPanel = document.querySelector('[data-role="partner-men-panel"]');
    var partnerWomenPanel = document.querySelector('[data-role="partner-women-panel"]');

    var partnerWBraletteImageEl = document.querySelector('[data-role="partner-w-bralette-image"]');
    var partnerWBraletteNameEl = document.querySelector('[data-role="partner-w-bralette-name"]');
    var partnerWBralettePriceEl = document.querySelector('[data-role="partner-w-bralette-price"]');
    var partnerWBraletteSizesEl = document.querySelector('[data-role="partner-w-bralette-sizes"]');

    var partnerWBottomGrid = document.querySelector('[data-role="partner-w-bottom-grid"]');
    var partnerWBottomButtons = partnerWBottomGrid
    ? Array.prototype.slice.call(partnerWBottomGrid.querySelectorAll('.bundle-builder__style-card[data-type]'))
    : [];
    var partnerWBottomSizesEl = document.querySelector('[data-role="partner-w-bottom-sizes"]');

    // NOTE: Women's bralette does NOT get its own data source. It reuses
    // the SAME swatch data (name/price/image/sizes/size guide) that Step 2
    // already reads from `.swatch-a-tag-custom[data-...]` — no new
    // collection or metafield needed. Only the SIZE selection is kept
    // independent (separate size-list container) so the customer's own
    // bralette size and the partner's bralette size can differ.

    var partnerTab = 'men'; // 'men' | 'women'
    var partnerItemCount = 1; // Men's = 1 item, Women's = 2 items (bralette + bottoms)

    var selectedPartnerWBraletteVariantId = null;
    var selectedPartnerWBraletteCents = 0;
    var selectedPartnerWBraletteSizeGuide = null;

    var selectedPartnerWBottomType = null;
    var selectedPartnerWBottomVariantId = null;
    var selectedPartnerWBottomCents = 0;
    var selectedPartnerWBottomSizeGuide = null;

    // Keeps the "Size guide" button on the Partner step pointed at
    // whichever tab (Men's / Women's) is currently visible.
    function syncPartnerSizeGuide() {
    selectedPartnerSizeGuide = partnerTab === 'men' ? partnerMenSizeGuide : selectedPartnerWBraletteSizeGuide;
    }

    var bottomsData = [];
    try {
    bottomsData = JSON.parse(document.getElementById('bundle-builder-bottoms-data').textContent);
    } catch (e) {
    bottomsData = [];
    }
    var bottomsMap = {};
    bottomsData.forEach(function (r) {
    if (!bottomsMap[r.type]) bottomsMap[r.type] = {};
    bottomsMap[r.type][r.style] = r;
    });

    var selectedBraletteVariantId = null;
    var selectedBottomType = null;
    var selectedBottomVariantId = null;
    var selectedBraletteCents = 0;
    var selectedBottomCents = 0;

    // ---------------------------------------------------------
    // remembered SIZE LABELS
    // Kept alongside each selected variant id, so that when a style
    // changes we can try to re-select the SAME size instead of
    // always falling back to the first available size (XXS bug fix).
    // ---------------------------------------------------------
    var selectedBraletteSizeLabel = null;
    var selectedBottomSizeLabel = null;
    var selectedPartnerSizeLabel = null;
    var selectedPartnerWBraletteSizeLabel = null;
    var selectedPartnerWBottomSizeLabel = null;


    var isInitialLoad = true;

    // ---------------------------------------------------------
    // CURRENCY / MONEY FORMATTING
    // ---------------------------------------------------------
    function formatMoney(cents) {
    var currencyCode = window.byobCartCurrency || 'USD';
    var amount = (cents || 0) / 100;

    if (currencyCode === 'CAD') {
        return '$' + amount.toFixed(2) + ' CAD';
    }

    if (currencyCode === 'USD') {
        return '$' + amount.toFixed(2);
    }

    try {
        return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        }).format(amount);
    } catch (e) {
        return '$' + amount.toFixed(2) + ' ' + currencyCode;
    }
    }

    function updateTotalPrice() {
        var partnerCents = 0;
        if (partnerEnabled) {
            partnerCents = partnerTab === 'men'
            ? selectedPartnerCents
            : selectedPartnerWBraletteCents + selectedPartnerWBottomCents;
        }

        var subtotalCents = selectedBraletteCents + selectedBottomCents + partnerCents;
        var itemCount = 2 + (partnerEnabled ? partnerItemCount : 0);

        var discountPercent = 0;
        if (itemCount >= 5) {
            discountPercent = 20;
        } else if (itemCount >= 3) {
            discountPercent = 15;
        } else if (itemCount >= 2) {
            discountPercent = 10;
        }

        var discountCents = Math.round((subtotalCents * discountPercent) / 100);
        var totalCents = subtotalCents - discountCents;

        if (priceEl) priceEl.textContent = formatMoney(totalCents);

        if (summaryDiscountEl) {
            summaryDiscountEl.textContent = discountPercent > 0
                ? '(' + discountPercent + '% off)'
                : '';
        }

        // strikethrough original price, only shown when a discount is
        // actually applied (itemCount < 2 => no strike-through).
        if (summaryOriginalPriceEl) {
            summaryOriginalPriceEl.textContent = discountPercent > 0 ? formatMoney(subtotalCents) : '';
            summaryOriginalPriceEl.style.display = discountPercent > 0 ? '' : 'none';
        }

        var addBtnPriceEl = document.querySelector('[data-role="add-btn-total-price"]');
        if (addBtnPriceEl) addBtnPriceEl.textContent = formatMoney(totalCents);

        if (addBtnOriginalPriceEl) {
            addBtnOriginalPriceEl.textContent = discountPercent > 0 ? formatMoney(subtotalCents) : '';
        }

        if (saveMessageEl) {
            saveMessageEl.style.color = '#2f7d5b';
            if (discountPercent > 0) {
            saveMessageEl.textContent = 'You saved ' + discountPercent + '% — ' + formatMoney(discountCents) + ' off';
            } else {
            saveMessageEl.textContent = defaultSaveMessage;
            }
        }
        if (mobileItemsEl) mobileItemsEl.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
        if (mobileTotalEl) mobileTotalEl.textContent = formatMoney(totalCents);
        if (mobileDiscountEl) mobileDiscountEl.textContent = discountPercent > 0 ? discountPercent + '% off applied' : '';
    }

    // ---------------------------------------------------------
    // Reusable: renders a size-button list into `container`.
    // Accepts a `preferredLabel` — if a size with that label exists
    // AND is available, it gets re-selected instead of always
    // defaulting to the first available size.
    // `onSelect` receives (variantId, label) so callers can keep
    // track of the label to pass back in next time.
    // ---------------------------------------------------------
    function renderSizeList(container, sizes, onSelect, preferredLabel) {
    if (!container) return;
    container.innerHTML = '';
    var preferredBtn = null;

    sizes.forEach(function (size) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className =
        'bundle-builder__size-option' + (size.available ? '' : ' bundle-builder__size-option--unavailable');
        btn.textContent = size.size;
        btn.dataset.variantId = size.id;
        if (!size.available) btn.disabled = true;

        if (size.available && preferredLabel && size.size === preferredLabel) {
        preferredBtn = btn;
        }

        container.appendChild(btn);
    });

    var toSelect = preferredBtn || container.querySelector('.bundle-builder__size-option:not(:disabled)');
    if (toSelect) {
        toSelect.classList.add('bundle-builder__size-option--selected');
    }
    if (onSelect) onSelect(toSelect ? toSelect.dataset.variantId : null, toSelect ? toSelect.textContent : null);

    container.onclick = function (e) {
        var btn = e.target.closest('.bundle-builder__size-option');
        if (!btn || btn.disabled) return;

        container.querySelectorAll('.bundle-builder__size-option').forEach(function (b) {
        b.classList.remove('bundle-builder__size-option--selected');
        });
        btn.classList.add('bundle-builder__size-option--selected');
        if (onSelect) onSelect(btn.dataset.variantId, btn.textContent);
    };
    }

    // Shows/hides bottom-type buttons for the current print, and keeps a valid selection
    function refreshBottoms(currentStyle) {
        bottomButtons.forEach(function (btn) {
            var type = btn.dataset.type;
            var record = bottomsMap[type] && bottomsMap[type][currentStyle];

            if (record && record.available) {
                btn.classList.remove('bundle-builder__style-card--hidden');

                var imgEl = btn.querySelector('[data-role="image"]');
                var priceEl2 = btn.querySelector('[data-role="price"]');

                if (imgEl) {
                    imgEl.style.backgroundImage = 'url("' + record.image + '")';
                    imgEl.style.backgroundSize = 'cover';
                    imgEl.style.backgroundPosition = 'center';
                }

                if (priceEl2) {
                    priceEl2.textContent = formatMoney(record.price_cents);
                }
            } else {
                btn.classList.add('bundle-builder__style-card--hidden');
                btn.classList.remove('bundle-builder__style-card--selected');
            }
        });

        // Show/hide the "Not available in this print" placeholder
        var visibleBottomButtons = bottomButtons.filter(function (b) {
            return !b.classList.contains('bundle-builder__style-card--hidden');
        });
        var bottomUnavailableCard = document.querySelector('[data-role="bottom-unavailable"]');
        if (bottomUnavailableCard) {
            bottomUnavailableCard.style.display = visibleBottomButtons.length === 0 ? '' : 'none';
        }
        // ---------------------------------------------------------
        // Find currently selected bottom
        // ---------------------------------------------------------
        var selectedBtn = bottomButtons.filter(function (b) {
            return (
                b.classList.contains('bundle-builder__style-card--selected') &&
                !b.classList.contains('bundle-builder__style-card--hidden')
            );
        })[0];

        // ---------------------------------------------------------
        // If no bottom is selected, automatically select
        // the first available bottom.
        // ---------------------------------------------------------
        if (!selectedBtn) {
            selectedBtn = bottomButtons.filter(function (b) {
                return !b.classList.contains('bundle-builder__style-card--hidden');
            })[0];

            if (selectedBtn) {
                selectedBtn.classList.add(
                    'bundle-builder__style-card--selected'
                );
            }
        }

        // ---------------------------------------------------------
        // Get selected bottom record
        // ---------------------------------------------------------
        var selectedRecord = null;

        if (selectedBtn) {
            selectedBottomType = selectedBtn.dataset.type;

            selectedRecord =
                bottomsMap[selectedBottomType] &&
                bottomsMap[selectedBottomType][currentStyle];
        } else {
            selectedBottomType = null;
        }

        // ---------------------------------------------------------
        // Update summary
        // ---------------------------------------------------------
        if (summaryBottomName) {
            summaryBottomName.textContent =
                selectedBottomType || '—';
        }

        if (summaryBottomPrice) {
            summaryBottomPrice.textContent = selectedRecord
                ? formatMoney(selectedRecord.price_cents)
                : '—';
        }

        selectedBottomCents = selectedRecord
            ? selectedRecord.price_cents
            : 0;

        selectedBottomSizeGuide = selectedRecord
            ? selectedRecord.size_guide
            : null;

        // ---------------------------------------------------------
        // Update BOTTOM thumbnail (low-res chip)
        // ---------------------------------------------------------
        var bottomThumbBtn = document.querySelector('[data-role="preview-thumb-bottom"]');

        if (selectedRecord && selectedRecord.image) {
            if (bottomThumbBtn) bottomThumbBtn.style.display = '';
            if (previewThumbBottomImg) {
                previewThumbBottomImg.style.backgroundImage = 'url("' + selectedRecord.image + '")';
                previewThumbBottomImg.style.backgroundSize = 'cover';
                previewThumbBottomImg.style.backgroundPosition = 'center';
            }
        } else {
            if (bottomThumbBtn) {
                bottomThumbBtn.style.display = 'none';

                // agar bottom thumbnail hi active tha, bralette pe wapas switch karo
                if (bottomThumbBtn.classList.contains('bundle-builder__preview-thumb--active')) {
                    var braletteThumb = document.querySelector('[data-role="preview-thumb-bralette"]');
                    if (braletteThumb) braletteThumb.click();
                }
            }
            if (previewThumbBottomImg) previewThumbBottomImg.style.backgroundImage = '';
        }

        // ---------------------------------------------------------
        // IMPORTANT:
        // On initial page load:
        // - bottom IS selected
        // - bottom thumbnail IS populated
        // - BUT bralette remains the active preview
        //
        // After user changes bottom:
        // - bottom becomes active preview
        //
        // IMAGE QUALITY FIX: hero window now uses `image_large`
        // (high-res) instead of the small chip's `image`.
        // ---------------------------------------------------------
        if (selectedRecord && selectedRecord.image) {

            var bottomThumb = document.querySelector(
                '[data-role="preview-thumb-bottom"]'
            );

            if (!isInitialLoad) {
                // User interaction → show bottom in hero (high-res)
                setHeroImage(selectedRecord.image_large || selectedRecord.image);

                previewThumbButtons.forEach(function (thumb) {
                    thumb.classList.remove(
                        'bundle-builder__preview-thumb--active'
                    );
                });

                if (bottomThumb) {
                    bottomThumb.classList.add(
                        'bundle-builder__preview-thumb--active'
                    );
                }
            }
        }

        // ---------------------------------------------------------
        // Bottom size
        // ---------------------------------------------------------
        renderSizeList(
            bottomSizesEl,
            selectedRecord ? selectedRecord.sizes : [],
            function (variantId, label) {
                selectedBottomVariantId = variantId;
                selectedBottomSizeLabel = label;
            },
            selectedBottomSizeLabel
        );

        updateTotalPrice();
    }

    // ---------------------------------------------------------
    // PARTNER summary — single place that decides what the
    // "Your Bundle" rows show, for both Men's and Women's tabs.
    // (Replaces the old inline summary-setting code that used to
    // live directly inside refreshPartner().)
    // ---------------------------------------------------------
    function refreshPartnerSummary() {
    if (!partnerEnabled) {
        if (summaryPartnerRow) summaryPartnerRow.classList.add('bundle-builder__summary-item--disabled');
        if (summaryPartnerRow2) summaryPartnerRow2.style.display = 'none';
        if (partnerTab === 'men' && summaryPartnerName && partnerNameEl) {
        summaryPartnerName.textContent = 'Partner — ' + partnerNameEl.textContent;
        }
        if (summaryPartnerPrice) summaryPartnerPrice.textContent = '—';
        updateTotalPrice();
        return;
    }

    if (partnerTab === 'men') {
        if (summaryPartnerRow2) summaryPartnerRow2.style.display = 'none';
        if (summaryPartnerRow) summaryPartnerRow.classList.remove('bundle-builder__summary-item--disabled');
        if (summaryPartnerName && partnerNameEl) summaryPartnerName.textContent = 'Partner — ' + partnerNameEl.textContent;
        if (summaryPartnerPrice) summaryPartnerPrice.textContent = formatMoney(selectedPartnerCents);
    } else {
        if (summaryPartnerRow) summaryPartnerRow.classList.remove('bundle-builder__summary-item--disabled');
        if (summaryPartnerName && partnerWBraletteNameEl) {
        summaryPartnerName.textContent = 'Partner — ' + partnerWBraletteNameEl.textContent;
        }
        if (summaryPartnerPrice) summaryPartnerPrice.textContent = formatMoney(selectedPartnerWBraletteCents);

        if (summaryPartnerRow2) {
        summaryPartnerRow2.style.display = '';
        summaryPartnerRow2.classList.remove('bundle-builder__summary-item--disabled');
        }
        if (summaryPartnerName2) summaryPartnerName2.textContent = 'Partner — ' + (selectedPartnerWBottomType || '');
        if (summaryPartnerPrice2) summaryPartnerPrice2.textContent = formatMoney(selectedPartnerWBottomCents);
    }

    updateTotalPrice();
    }

    // ---------------------------------------------------------
    // PARTNER (MEN'S) refresh
    // ---------------------------------------------------------
    function refreshPartner(currentStyle) {
    var normalizedStyle = (currentStyle || '').trim().toLowerCase();
    var record = partnerMap[normalizedStyle];

    if (record && record.available) {
        if (partnerImageEl) {
        partnerImageEl.style.backgroundImage = 'url(' + record.image + ')';
        partnerImageEl.style.backgroundSize = 'cover';
        partnerImageEl.style.backgroundPosition = 'center';
        }
        if (partnerNameEl) partnerNameEl.textContent = record.name;
        if (partnerPriceEl) partnerPriceEl.textContent = formatMoney(record.price_cents);

        selectedPartnerCents = record.price_cents;
        partnerMenSizeGuide = record.size_guide || null;

        // Store men's thumbnail (low-res) + hero (high-res) images;
        // only paints them if Men's tab is active.
        partnerMenThumbImage = record.image;
        partnerMenHeroImage = record.image_large || record.image;
        updatePartnerThumbDisplay();

        renderSizeList(partnerSizesEl, record.sizes, function (variantId, label) {
        selectedPartnerVariantId = variantId;
        selectedPartnerSizeLabel = label;
        }, selectedPartnerSizeLabel);
    } else {
        if (partnerImageEl) partnerImageEl.style.backgroundImage = '';
        if (partnerNameEl) partnerNameEl.textContent = 'Not available in this print';
        if (partnerPriceEl) partnerPriceEl.textContent = '—';

        selectedPartnerVariantId = null;
        selectedPartnerCents = 0;
        partnerMenSizeGuide = null;
        partnerMenThumbImage = null;
        partnerMenHeroImage = null;

        if (partnerSizesEl) partnerSizesEl.innerHTML = '';
    }

    syncPartnerSizeGuide();
    refreshPartnerSummary();
    }

    // ---------------------------------------------------------
    // PARTNER (WOMEN'S) refresh
    // Bralette: reuses the CURRENT SWATCH's own data — the exact same
    // name/price/image/sizes/size-guide that Step 2 shows for the
    // customer's own bralette (there's only one style, so no separate
    // "partner bralette product" exists — it's the same product, just a
    // second, independent size selection for the partner).
    // Bottoms: reuses `bottomsMap` (same collection/types as Step 3),
    // with its own independent style + size selection.
    // ---------------------------------------------------------
    function refreshPartnerWomen(swatch) {
        var currentStyle = swatch ? swatch.dataset.style : null;
        partnerWomenThumbImage = null;
        partnerWomenHeroImage = null;
        partnerWomenBraletteThumbImage = null;
        // =========================================================
        // WOMEN'S PARTNER BRALETTE
        // This is shown inside the Women's partner panel,
        // but NOT used as the partner preview thumbnail.
        // =========================================================
        if (swatch) {
            partnerWomenBraletteThumbImage = swatch.dataset.image || null; 
            if (partnerWBraletteImageEl && swatch.dataset.image) {
                partnerWBraletteImageEl.style.backgroundImage =
                    'url(' + swatch.dataset.image + ')';
                partnerWBraletteImageEl.style.backgroundSize = 'cover';
                partnerWBraletteImageEl.style.backgroundPosition = 'center';
            }

            if (partnerWBraletteNameEl) {
                partnerWBraletteNameEl.textContent = swatch.dataset.name;
            }

            var braletteCents =
                parseInt(swatch.dataset.priceCents, 10) || 0;

            if (partnerWBralettePriceEl) {
                partnerWBralettePriceEl.textContent =
                    formatMoney(braletteCents);
            }

            selectedPartnerWBraletteCents = braletteCents;

            var braletteSizeGuide = null;

            try {
                braletteSizeGuide =
                    JSON.parse(swatch.dataset.sizeGuide);
            } catch (e) {
                braletteSizeGuide = null;
            }

            selectedPartnerWBraletteSizeGuide = braletteSizeGuide;

            var braletteSizes = [];

            try {
                braletteSizes =
                    JSON.parse(swatch.dataset.sizes);
            } catch (e) {
                braletteSizes = [];
            }

            renderSizeList(
                partnerWBraletteSizesEl,
                braletteSizes,
                function (variantId, label) {
                    selectedPartnerWBraletteVariantId = variantId;
                    selectedPartnerWBraletteSizeLabel = label;
                },
                selectedPartnerWBraletteSizeLabel
            );
        } else {
            if (partnerWBraletteImageEl) {
                partnerWBraletteImageEl.style.backgroundImage = '';
            }

            if (partnerWBraletteNameEl) {
                partnerWBraletteNameEl.textContent = 'Not available';
            }

            if (partnerWBralettePriceEl) {
                partnerWBralettePriceEl.textContent = '—';
            }

            selectedPartnerWBraletteVariantId = null;
            selectedPartnerWBraletteCents = 0;
            selectedPartnerWBraletteSizeGuide = null;

            if (partnerWBraletteSizesEl) {
                partnerWBraletteSizesEl.innerHTML = '';
            }
        }


        // =========================================================
        // WOMEN'S PARTNER BOTTOMS
        // =========================================================

        partnerWBottomButtons.forEach(function (btn) {
            var type = btn.dataset.type;

            var record =
                bottomsMap[type] &&
                bottomsMap[type][currentStyle];

            if (record && record.available) {
                btn.classList.remove(
                    'bundle-builder__style-card--hidden'
                );

                var imgEl =
                    btn.querySelector('[data-role="image"]');

                var priceEl2 =
                    btn.querySelector('[data-role="price"]');

                if (imgEl) {
                    imgEl.style.backgroundImage =
                        'url(' + record.image + ')';
                    imgEl.style.backgroundSize = 'cover';
                    imgEl.style.backgroundPosition = 'center';
                }

                if (priceEl2) {
                    priceEl2.textContent =
                        formatMoney(record.price_cents);
                }
            } else {
                btn.classList.add(
                    'bundle-builder__style-card--hidden'
                );

                btn.classList.remove(
                    'bundle-builder__style-card--selected'
                );
            }
        });

        // Show/hide the "Not available in this print" placeholder
        var visiblePartnerWBottomButtons = partnerWBottomButtons.filter(function (b) {
            return !b.classList.contains('bundle-builder__style-card--hidden');
        });
        var partnerWBottomUnavailableCard = document.querySelector('[data-role="partner-w-bottom-unavailable"]');
        if (partnerWBottomUnavailableCard) {
            partnerWBottomUnavailableCard.style.display = visiblePartnerWBottomButtons.length === 0 ? '' : 'none';
        }

        // =========================================================
        // FIND SELECTED WOMEN'S BOTTOM
        // =========================================================

        var selectedBtn = partnerWBottomButtons.filter(function (b) {
            return b.classList.contains(
                'bundle-builder__style-card--selected'
            );
            })[0];

            var selectedVisible =
                selectedBtn &&
                !selectedBtn.classList.contains(
                    'bundle-builder__style-card--hidden'
                );

            if (!selectedVisible) {
                var firstVisible =
                    partnerWBottomButtons.filter(function (b) {
                        return !b.classList.contains(
                            'bundle-builder__style-card--hidden'
                        );
                    })[0];

                if (firstVisible) {
                    firstVisible.classList.add(
                        'bundle-builder__style-card--selected'
                    );
                }

                selectedBtn = firstVisible;
            }


            // =========================================================
            // GET ACTUAL SELECTED BOTTOM DATA
            // =========================================================

            var bottomRecord = null;

            if (selectedBtn) {
                selectedPartnerWBottomType =
                    selectedBtn.dataset.type;

                bottomRecord =
                    bottomsMap[selectedPartnerWBottomType] &&
                    bottomsMap[selectedPartnerWBottomType][currentStyle];
            } else {
                selectedPartnerWBottomType = null;
            }

            selectedPartnerWBottomCents =
                bottomRecord
                    ? bottomRecord.price_cents
                    : 0;

            selectedPartnerWBottomSizeGuide =
                bottomRecord
                    ? bottomRecord.size_guide
                    : null;


            // =========================================================
            // IMPORTANT:
            // WOMEN'S PARTNER PREVIEW THUMBNAIL
            //
            // Only the Women's BOTTOM should appear here.
            // Women's partner bralette is intentionally ignored.
            //
            // IMAGE QUALITY FIX: hero window uses `image_large`
            // (high-res) instead of the small chip's `image`.
            // =========================================================

                if (bottomRecord && bottomRecord.image) {
                    partnerWomenThumbImage = bottomRecord.image;
                    partnerWomenHeroImage = bottomRecord.image_large || bottomRecord.image;

                    // Update partner thumbnail
                    updatePartnerThumbDisplay();

                    // IMPORTANT:
                    // Whenever Women's partner bottom changes,
                    // also update the main preview image (high-res).
                    if (partnerTab === 'women') {
                        setHeroImage(partnerWomenHeroImage);

                        // Make partner thumbnail active
                        previewThumbButtons.forEach(function (thumb) {
                            thumb.classList.remove(
                                'bundle-builder__preview-thumb--active'
                            );
                        });

                        if (previewThumbPartnerBtn) {
                            previewThumbPartnerBtn.classList.add(
                                'bundle-builder__preview-thumb--active'
                            );
                        }
                    }
                }else {
                    partnerWomenThumbImage = null;
                    partnerWomenHeroImage = null;

                    if (partnerTab === 'women' && previewThumbPartnerImg) {
                        previewThumbPartnerImg.style.backgroundImage = '';
                    }
                }


            // =========================================================
            // WOMEN'S BOTTOM SIZE
            // =========================================================

            renderSizeList(
                partnerWBottomSizesEl,
                bottomRecord ? bottomRecord.sizes : [],
                function (variantId, label) {
                    selectedPartnerWBottomVariantId = variantId;
                    selectedPartnerWBottomSizeLabel = label;
                },
                selectedPartnerWBottomSizeLabel
            );


        syncPartnerSizeGuide();
        refreshPartnerSummary();
    }

    bottomButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            if (this.classList.contains('bundle-builder__style-card--hidden')) return;
            bottomButtons.forEach(function (b) {
            b.classList.remove('bundle-builder__style-card--selected');
            });
            this.classList.add('bundle-builder__style-card--selected');

            var activeSwatch = document.querySelector('.swatch-a-tag-custom.border-blue-500');
            refreshBottoms(activeSwatch ? activeSwatch.dataset.style : null);
        });
    });

    // ---------------------------------------------------------
    // BRALETTE card click → hero image = bralette image
    // ---------------------------------------------------------
    var braletteCard = document.querySelector('.bundle-builder__step--bralette .bundle-builder__style-card');
    if (braletteCard) {
        braletteCard.addEventListener('click', function () {
            var activeSwatch = document.querySelector('.swatch-a-tag-custom.border-blue-500');
            if (activeSwatch && activeSwatch.dataset.image) {
                setHeroImage(activeSwatch.dataset.image);
            }

            previewThumbButtons.forEach(function (thumb) {
                thumb.classList.remove('bundle-builder__preview-thumb--active');
            });

            var braletteThumb = document.querySelector('[data-role="preview-thumb-bralette"]');
            if (braletteThumb) braletteThumb.classList.add('bundle-builder__preview-thumb--active');
        });
    }

    // ---------------------------------------------------------
    // PARTNER (MEN'S) card click → hero image = partner image
    // ---------------------------------------------------------
    var partnerMenCard = partnerMenPanel ? partnerMenPanel.querySelector('.bundle-builder__style-card') : null;
    if (partnerMenCard) {
        partnerMenCard.addEventListener('click', function () {
            if (!partnerEnabled || !partnerMenHeroImage) return;

            setHeroImage(partnerMenHeroImage);

            previewThumbButtons.forEach(function (thumb) {
                thumb.classList.remove('bundle-builder__preview-thumb--active');
            });

            if (previewThumbPartnerBtn) {
                previewThumbPartnerBtn.classList.add('bundle-builder__preview-thumb--active');
            }
        });

        // ---------------------------------------------------------
        // PARTNER WOMEN'S bralette card click → hero image = partner's bralette
        // ---------------------------------------------------------
        var partnerWomenBraletteCard = partnerWomenPanel
            ? partnerWomenPanel.querySelector('.bundle-builder__style-card:not([data-type])')
            : null;

        if (partnerWomenBraletteCard) {
            partnerWomenBraletteCard.addEventListener('click', function () {
                if (!partnerEnabled || partnerTab !== 'women' || !partnerWomenBraletteThumbImage) return;

                setHeroImage(partnerWomenBraletteThumbImage);

                previewThumbButtons.forEach(function (thumb) {
                    thumb.classList.remove('bundle-builder__preview-thumb--active');
                });

                if (previewThumbPartnerBraletteBtn) {
                    previewThumbPartnerBraletteBtn.classList.add('bundle-builder__preview-thumb--active');
                }
            });
        }
    }

    // Women's partner bottoms buttons
    partnerWBottomButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
        if (this.classList.contains('bundle-builder__style-card--hidden')) return;
        partnerWBottomButtons.forEach(function (b) {
        b.classList.remove('bundle-builder__style-card--selected');
        });
        this.classList.add('bundle-builder__style-card--selected');

        var activeSwatch = document.querySelector('.swatch-a-tag-custom.border-blue-500');
        refreshPartnerWomen(activeSwatch);
    });
    });

    function updateSummarySwatch(element, image) {
    if (!element) return;

    if (image) {
        element.style.backgroundImage = 'url("' + image + '")';
        element.style.backgroundSize = 'cover';
        element.style.backgroundPosition = 'center';
        element.style.backgroundColor = '';
    } else {
        element.style.backgroundImage = '';
        element.style.backgroundColor = '#e7ddcf';
    }
    }

    function selectSwatch(swatch) {

        // ---------------------------------------------------------
        // SWATCH CHANGE:
        // Always reset preview selection back to BRalette.
        // Bottom will be auto-selected internally by refreshBottoms(),
        // but it must NOT remain the active preview.
        // ---------------------------------------------------------
        bottomButtons.forEach(function (b) {
            b.classList.remove(
                'bundle-builder__style-card--selected'
            );
        });

        selectedBottomType = null;
        selectedBottomVariantId = null;

        // Remove active state from all preview thumbnails
        previewThumbButtons.forEach(function (thumb) {
            thumb.classList.remove(
                'bundle-builder__preview-thumb--active'
            );
        });

        // ---------------------------------------------------------
        // Bralette thumbnail becomes active
        // ---------------------------------------------------------
        var braletteThumb = document.querySelector(
            '[data-role="preview-thumb-bralette"]'
        );

        if (braletteThumb) {
            braletteThumb.classList.add(
                'bundle-builder__preview-thumb--active'
            );
        }

        swatches.forEach(function (s) {
            s.classList.remove('border-blue-500', 'border', 'border-solid');
        });
        swatch.classList.add('border-blue-500', 'border', 'border-solid');

        if (tagEl) tagEl.textContent = 'Print: ' + swatch.dataset.style;
        if (captionEl) captionEl.textContent = 'Your matching set — ' + swatch.dataset.style;
        if (imageEl && swatch.dataset.image) {
            imageEl.style.backgroundImage = 'url(' + swatch.dataset.image + ')';
            imageEl.style.backgroundSize = 'cover';
            imageEl.style.backgroundPosition = 'center';
        }

        if (braletteImageEl && swatch.dataset.image) {
            braletteImageEl.style.backgroundImage = 'url(' + swatch.dataset.image + ')';
            braletteImageEl.style.backgroundSize = 'cover';
            braletteImageEl.style.backgroundPosition = 'center';
        }
        if (braletteNameEl) braletteNameEl.textContent = swatch.dataset.name;
        if (bralettePriceEl) bralettePriceEl.textContent = formatMoney(parseInt(swatch.dataset.priceCents, 10) || 0);

        // update the bralette preview thumbnail
        if (previewThumbBraletteImg && swatch.dataset.image) {
            previewThumbBraletteImg.style.backgroundImage = 'url(' + swatch.dataset.image + ')';
            previewThumbBraletteImg.style.backgroundSize = 'cover';
            previewThumbBraletteImg.style.backgroundPosition = 'center';
        }

        if (summaryBraletteName) {
            summaryBraletteName.textContent = swatch.dataset.name;
        }

        if (summaryBraletteSwatch) {
            updateSummarySwatch(summaryBraletteSwatch, swatch.dataset.image);
        }

        if (summaryBottomSwatch) {
            updateSummarySwatch(summaryBottomSwatch, swatch.dataset.image);
        }

        if (summaryPartnerSwatch) {
            updateSummarySwatch(summaryPartnerSwatch, swatch.dataset.image);
        }

        if (summaryPartnerSwatch2) {
            updateSummarySwatch(summaryPartnerSwatch2, swatch.dataset.image);
        }

        selectedBraletteCents = parseInt(swatch.dataset.priceCents, 10) || 0;

        if (summaryBralettePrice) summaryBralettePrice.textContent = formatMoney(selectedBraletteCents);

        var sizes = [];
        try {
            sizes = JSON.parse(swatch.dataset.sizes);
        } catch (e) {
            sizes = [];
        }
        renderSizeList(braletteSizesEl, sizes, function (variantId, label) {
            selectedBraletteVariantId = variantId;
            selectedBraletteSizeLabel = label;
        }, selectedBraletteSizeLabel);

        refreshBottoms(swatch.dataset.style);
        refreshPartner(swatch.dataset.style);
        refreshPartnerWomen(swatch);

        // ---------------------------------------------------------
        // IMPORTANT:
        // After all refreshes, swatch change must ALWAYS end on
        // the BRalette preview.
        // ---------------------------------------------------------
        if (swatch.dataset.image) {
            setHeroImage(swatch.dataset.image);
        }

        previewThumbButtons.forEach(function (thumb) {
            thumb.classList.remove(
                'bundle-builder__preview-thumb--active'
            );
        });

        var braletteThumb = document.querySelector(
            '[data-role="preview-thumb-bralette"]'
        );

        if (braletteThumb) {
            braletteThumb.classList.add(
                'bundle-builder__preview-thumb--active'
            );
        }
    }

    var defaultSwatch =
        document.querySelector('.swatch-a-tag-custom[data-selected="true"]') ||
        swatches[0];

    if (defaultSwatch) {
        selectSwatch(defaultSwatch);
    }

    // Initial preview should always start with the bralette.
    if (previewThumbButtons && previewThumbButtons.length) {
        previewThumbButtons.forEach(function (thumb) {
            thumb.classList.remove('bundle-builder__preview-thumb--active');
        });

        var braletteThumb = document.querySelector(
            '[data-role="preview-thumb-bralette"]'
        );

        if (braletteThumb) {
            braletteThumb.classList.add(
                'bundle-builder__preview-thumb--active'
            );
        }
    }

    // Now normal user interactions can auto-refresh as expected.
    isInitialLoad = false;

    swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
        e.preventDefault();
        selectSwatch(this);
    });
    });

    // ---------------------------------------------------------
    // PARTNER toggle
    // ---------------------------------------------------------
    if (partnerToggle) {
        partnerToggle.addEventListener('click', function () {
            partnerEnabled = !partnerEnabled;

            if (partnerContent) {
            partnerContent.style.opacity = partnerEnabled ? '1' : '0.45';
            partnerContent.style.pointerEvents = partnerEnabled ? 'auto' : 'none';
            }
            this.style.background = partnerEnabled ? '#1e2a5e' : '';
            var knob = this.querySelector('span');
            if (knob) knob.style.left = partnerEnabled ? '23px' : '3px';

            // updatePartnerThumbDisplay() already handles hiding BOTH partner
            // thumbnails (Men's/Women's boxer AND Women's bralette) correctly
            // when partnerEnabled is false — always calling it here (instead
            // of only when enabled) fixes the bralette thumb staying visible
            // after toggling off.
            updatePartnerThumbDisplay();

            refreshPartnerSummary();
        });
    }

    // ---------------------------------------------------------
    // PARTNER Men's / Women's tab switch
    // ---------------------------------------------------------
    partnerTabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
        partnerTab = this.dataset.partnerTab;
        partnerItemCount = partnerTab === 'women' ? 2 : 1;

        partnerTabButtons.forEach(function (b) {
        b.classList.toggle('bundle-builder__partner-tab--selected', b === btn);
        });
        if (partnerMenPanel) partnerMenPanel.style.display = partnerTab === 'men' ? '' : 'none';
        if (partnerWomenPanel) partnerWomenPanel.style.display = partnerTab === 'women' ? '' : 'none';

        syncPartnerSizeGuide();
        updatePartnerThumbDisplay();
        refreshPartnerSummary();
    });
    });

    // ---------------------------------------------------------
    // ADD TO CART
    // ---------------------------------------------------------
    var addButton = document.querySelector('.bundle-builder__add-button');

    function setAddButtonLoading(isLoading) {
    if (!addButton) return;
    addButton.disabled = isLoading;
    }

    function showBundleMessage(message, isError) {
        if (!saveMessageEl) return;
        saveMessageEl.style.color = isError ? '#c0392b' : '#2f7d5b';
        saveMessageEl.textContent = message;

        if (isError) {
            saveMessageEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    // Opens (and refreshes) the site's cart drawer using the same
    // pattern already used elsewhere on this store (see the
    // "matching-app" bundle flow's addBundleToCart method).
    function openCartDrawer() {
    // Refresh cart contents (line items, totals, etc.)
    document.dispatchEvent(
        new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { updatedCart: true },
        })
    );

    // Reveal the drawer overlay/panel
    document.body.classList.add('open-cart', 'open-cc');

    var cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer) {
        cartDrawer.classList.add('active');
        if (typeof cartDrawer.notesToggle === 'function') cartDrawer.notesToggle();
        if (typeof cartDrawer.removeProductEvent === 'function') cartDrawer.removeProductEvent();
    }

    if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart-drawer:open');
    }
    }

    if (addButton) {
        addButton.addEventListener('click', function () {
            if (!selectedBraletteVariantId) {
                showBundleMessage('Please select a bralette size.', true);
                return;
            }
            if (!selectedBottomVariantId) {
            showBundleMessage('Please select a bottoms size.', true);
            return;
            }

            var bundleSourceProps = { '_bundle_source': 'build_your_bundle' };

            var items = [
            { id: selectedBraletteVariantId, quantity: 1, properties: bundleSourceProps },
            { id: selectedBottomVariantId, quantity: 1, properties: bundleSourceProps },
            ];

            if (partnerEnabled) {
            if (partnerTab === 'men') {
                if (!selectedPartnerVariantId) {
                showBundleMessage('Please select a partner boxer size.', true);
                return;
                }
                items.push({ id: selectedPartnerVariantId, quantity: 1, properties: bundleSourceProps });
            } else {
                if (!selectedPartnerWBraletteVariantId || !selectedPartnerWBottomVariantId) {
                showBundleMessage("Please select your partner's bralette and bottoms size.", true);
                return;
                }
                items.push({ id: selectedPartnerWBraletteVariantId, quantity: 1, properties: bundleSourceProps });
                items.push({ id: selectedPartnerWBottomVariantId, quantity: 1, properties: bundleSourceProps });
            }
            }
            setAddButtonLoading(true);

            fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
            })
            .then(function (res) {
                return res.json().then(function (data) {
                if (!res.ok) throw data;
                return data;
                });
            })
            .then(function () {
                setAddButtonLoading(false);
                showBundleMessage('Added to cart!', false);

                openCartDrawer();

                setTimeout(function () {
                showBundleMessage(defaultSaveMessage, false);
                }, 2500);
            })
            .catch(function (err) {
                setAddButtonLoading(false);
                var msg = (err && err.description) || 'Something went wrong, please try again.';
                showBundleMessage(msg, true);
            });
        });
    }
    if (mobileBarButton && addButton) {
      mobileBarButton.addEventListener('click', function () {
        addButton.click();
      });
    }
})();